module.exports = __webpack_public_path__ + "static/media/tire.fb587e22.png";